// src/components/Home.js (or wherever your CardComponent is)
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import back_video from './back.mp4';

import datasetsIcon from './icons_home/datasets_icon.png';
import codeIcon from './icons_home/code_icon.png';
import paperIcon from './icons_home/paper_icon.png';
import docsIcon from './icons_home/docs_icon.png';

// OR: If your video is hosted online (e.g., CDN), you don't need the import.
// Define the URL like this:
// const complex_video_url = 'https://your-cdn.com/path/to/your_video.mp4';


const CardComponent = () => {
  const navigate = useNavigate();

  const buttonLinks = [
    {
      key: 'dataset',
      text: 'Dataset',
      url: 'https://huggingface.co/datasets/CataAI/PoseX',
      type: 'external',
      icon: datasetsIcon,
    },
    {
      key: 'code',
      text: 'Code',
      url: 'https://github.com/CataAI/PoseX',
      type: 'external',
      icon: codeIcon,
    },
    {
      key: 'paper',
      text: 'Paper',
      url: 'https://openreview.net/pdf?id=qqzxKudD4T',
      type: 'external',
      icon: paperIcon,
    },
    {
      key: 'docs',
      text: 'Docs',
      path: '/docs',
      type: 'internal',
      icon: docsIcon,
    },
  ];

  const handleButtonClick = (linkInfo) => {
    if (linkInfo.type === 'internal' && linkInfo.path) {
      navigate(linkInfo.path);
    }
  };

  return (
    <div className="home-background">
      <video
        className="home-background-video"
        src={back_video}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />

      <div className="home-overlay">
        <p className="home-slogan">Define Standards for Real-world Docking</p>

        <div className="home-button-row" aria-label="Home actions">
          {buttonLinks.map((linkInfo, index) => {
            if (linkInfo.type === 'internal') {
              return (
                <button
                  key={index}
                  onClick={() => handleButtonClick(linkInfo)}
                  className="action-button home-action-button"
                  type="button"
                  aria-label={linkInfo.text}
                >
                  <img className="home-button-icon" src={linkInfo.icon} alt="" aria-hidden="true" />
                  <span className="home-button-text">{linkInfo.text}</span>
                </button>
              );
            }

            // External link
            return (
              <a
                key={index}
                href={linkInfo.url}
                className="action-button home-action-button"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={linkInfo.text}
              >
                <img className="home-button-icon" src={linkInfo.icon} alt="" aria-hidden="true" />
                <span className="home-button-text">{linkInfo.text}</span>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CardComponent;